export default "__VITE_ASSET__DcIfcyhk__"